module.exports = "/assets/data/66a9f50ed69d608feed196b36a0edd5b-DN16.data.json";